import './index.scss';
import React, { useEffect, useState } from 'react';

function TextControl({ structure, saveValue, defaultValue, controlKey, runtimeValue }) {

    const [controlValue, setControlValue] = useState(defaultValue ?? '');

    const handleChange = (e) => {
        let currentValue = e.currentTarget.value;
        setControlValue(currentValue);
        saveValue(currentValue);
    }

    useEffect(() => {
        if (typeof defaultValue !== 'undefined') {
            setControlValue(defaultValue);
        } else {
            setControlValue('');
        }
    }
        , [defaultValue]);

    return (
        <div className="tbcourse-editor-control-text">
            <input type="text" className="form-control" placeholder={structure.placeholder} value={runtimeValue ?? controlValue} onChange={handleChange}></input>
        </div>
    );
}

export default TextControl;
